<script>
import compoment from '@/components/draggable/CustomComponents/Radio/DRadioEditor'
export default {
  name: 'DPaginationEditor',
  extends: compoment
}
</script>
